import Tools from './tools';

export default class Nav {
  constructor() {
    // Nav
    this.navPosition();
    this.ancres();
    this.burgerMenu();
  }

  navPosition() {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > document.querySelector('section header').offsetHeight - document.querySelector('nav').offsetHeight) {
        document.querySelector('nav').classList.add('not-on-top');
      } else {
        document.querySelector('nav').classList.remove('not-on-top');
      }
    })
  }

  ancres() {
    const links = document.querySelectorAll('nav .wrapper .main-menu li a');
    if (links.length > 0) {
      links.forEach((link) => {
        if (link.hash) {
          link.addEventListener('click', (e) => {
            e.preventDefault();

            if (document.querySelector('nav .wrapper .main-menu').classList.contains('open')) {
              document.querySelector('nav .wrapper .main-menu').classList.remove('open');
              document.querySelector('nav .wrapper .burger').classList.remove('open');

            }
            window.scrollTo({
              top: Tools.offset(document.querySelector(link.hash)).top - 30,
              left: 0,
              behavior: 'smooth',
            });
          });
        }
      });
    }
  }

  burgerMenu() {
    const burgerBtn = document.querySelector('nav .wrapper .burger');
    if (burgerBtn) {
      burgerBtn.addEventListener('click', () => {
        burgerBtn.classList.toggle('open');
        document.querySelector('nav .wrapper .main-menu').classList.toggle('open');
      });
    }
  }
}